import { Box, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

function AuthIllustration(props) {
  const { children } = props;
  return (
    <Flex 
      position="relative" 
      h="100vh" 
      w="100vw" 
      overflow="hidden"
      bg="gray.50"
      _dark={{ bg: 'gray.900' }}
    >
      {/* Animated background */}
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        background="radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.1) 0%, transparent 50%)"
        _dark={{ background: "radial-gradient(circle at 20% 80%, rgba(66, 153, 225, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(159, 122, 234, 0.1) 0%, transparent 50%)" }}
        zIndex={0}
      />
      
      {children}
    </Flex>
  );
}

AuthIllustration.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthIllustration;